module.exports = __webpack_public_path__ + "img/WAREHOUSING.c4785b94.svg";